export function getListingPrice(nft) {
  return nft?.currentListingPrice ?? null;
}

export function getListingEndDate(nft) {
  return nft?.currentListingExpiryTimestamp ?? null;
}

export function getListingOrderKey(nft) {
  return nft?.currentListingOrderKey ?? null;
}

export function getAllListingOrderKeys(nfts) {
  return nfts.map((nft) => getListingOrderKey(nft)).filter((key) => key);
}
